import { Component, OnInit, ViewChild } from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalserviceService } from 'src/app/helpers/services/localservice.service';
import { Constant } from 'src/app/helpers/constants/constant';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { SharedAlertModelComponent } from 'src/app/common-shared-modules/shared-alert-model/shared-alert-model.component';
import { AlertSwipeComponent } from 'src/app/common-shared-modules/alert-swipe/alert-swipe.component';
import { dateOfBirthOnlyDirective } from 'src/app/common-shared-modules/directives/app-directive.directive';
import { saveAs } from 'file-saver';
@Component({
  selector: 'app-group-renewal-thank-you , ngbd-accordion-basic , ngbd-accordion-static',
  templateUrl: './group-renewal-thank-you.component.html',
  styleUrls: ['./group-renewal-thank-you.component.css']
})
export class GroupRenewalThankYouComponent implements OnInit {
  form: FormGroup;
  renewDetails = [];
  acceptTermsncondition = false;
  popupotheroffering = false;
  sessionStorageVal: any;
  ReferenceNo = [];
  thankYouPage: any;
  groupRenewDetails: any;
  newDateFormat: any;
  rateValue: any
  certificateNo: any;
  policyNoArray: any;
  activeIds: string[] = [];
  month: any;
  day: any;
  year: any;
  usertoken: any;

  // private alertSwipe =new AlertSwipeComponent()
  @ViewChild(AlertSwipeComponent) private alertSwipe:
    AlertSwipeComponent;
  messageObj: any;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    public appservice: LocalserviceService,
    public matDialog: MatDialog,
    public location: PlatformLocation,

  ) {
    location.onPopState(() => {
      history.pushState(null, null, window.location.href)
    })
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      description: ['', Validators.required],
    });
    this.fetchThankyouDetails()
    this.noBack()
    this.activeIds = ['static-0', 'static-1']; //panels 1 and 2 are open

  }

  noBack() {

  }
  /*---------------------- To Download Receipt ---------------------------*/
  downloadReceipt(groupRenewDetails) {
    this.usertoken = sessionStorage.getItem('ut');
    var currentdate = new Date();
    this.month = currentdate.getMonth() + 1;
    if (this.month < 10) {
      this.month = "0" + (currentdate.getMonth() + 1);
    }
    this.day = currentdate.getDate();
    if (this.day < 10) {
      this.day = "0" + currentdate.getDate();
    }
    this.year = currentdate.getFullYear();
    var newcurrentDate = this.month + '/' + this.day + '/' + this.year;

    var newCreatedDate = this.groupRenewDetails[0].PolicyStartDate;
    var data = {
      "TemplateId": "G23K23CF1AZ1B4BHD8K91",
      "Token": "uIhsjJfDOnGo3KZV6i47pywmFltAka5tk0lVVjLG",
      "TemplateData": [{
        "Key": "AMOUNT",
        "Value": groupRenewDetails.Premium
      },
      {
        "Key": "RECEIPTNUMBER",
        "Value": groupRenewDetails.ReceiptId
      },
      {
        "Key": "INSTRUMENTNUMBER",
        "Value": groupRenewDetails.InstrumentNumber
      },
      {
        "Key": "DATE",
        "Value": newcurrentDate
      },
      {
        "Key": "PROPOSERNAME",
        "Value": groupRenewDetails.FirstName + ' ' + groupRenewDetails.LastName
      },
      {
        "Key": "PAYMENTMODE",
        "Value": groupRenewDetails.ModeOfPayment
      },
      {
        "Key": "BANKNAME",
        "Value": ""
      },
      {
        "Key": "POLICYNUMBER",
        "Value": groupRenewDetails.PolicyNumber
      },
      {
        "Key": "PROPOSALNUMBER",
        "Value": groupRenewDetails.ProposalNumber
      },
      {
        "Key": "CURRENTDATE",
        "Value": newcurrentDate
      },
      {
        "Key": "FINANCIALYEAR",
        "Value": groupRenewDetails.FinancialYear
      }
      ],
      "TemplateKey": [],
      "TemplateDataPassed": true
    }
    this.appservice.show()
    this.appservice.PostApi(Constant.hpre_BaseUrl + '/TemplateGeneration/api/Template/GenerateTemplate', data, Constant.header).subscribe(res => {
      console.log(res);
      this.appservice.hide()
      if (res.ResponseCode == '1') {
        var URLToPDF = res.ResponseData.FileURL;
        var fileName = groupRenewDetails.PolicyNumber;
        saveAs(URLToPDF, fileName);
      } else if (res.ResponseCode == 0) {
        const alertModel = new MatDialogConfig();
        alertModel.disableClose = true;
        alertModel.id = "modal-component";
        alertModel.height = "270px";
        alertModel.width = "850px";
        alertModel.data = {
          title: "Alert Model",
          description: 'There seems to be a problem. Please try again after some time.',
          successText: "OK",
          failureText: "cancel",
          showSuccessBtn: true,
          showFaliureBtn: true,
        }
        const modalDialog = this.matDialog.open(SharedAlertModelComponent, alertModel);

      }
    });
  }
  /*---------------------- End of To Download Receipt --------------------*/

  /*---------------------- To fetch Thank You Details ---------------------------*/
  fetchThankyouDetails() {
    this.policyNoArray = []
    this.certificateNo = [];
    var sessionStorageVal = JSON.parse(sessionStorage.refNoArray);
    for (var i = 0; i < sessionStorageVal.length; i++) {
      this.ReferenceNo.push(sessionStorageVal[i].ReferenceNo);
      //this.certificateNo.push(sessionStorageVal[i].CertificateNumber);
    }
    this.appservice.show()
    this.appservice.PostApi(Constant.hpre_BaseUrl + '/api/groupRenew/TY', { "ReferenceNo": this.ReferenceNo[0], "PaymentType": "normal" }, Constant.header).subscribe(res => {
      console.log(res);
      this.appservice.hide()
      if (res.ResponseCode == '1') {
        this.thankYouPage = res.ResponseData;
        this.groupRenewDetails = res.ResponseData.ThankyouDetails;
        this.newDateFormat = new Date(this.groupRenewDetails[0].PolicyStartDate);
        for (var i = 0; i < this.groupRenewDetails.length; i++) {
          this.certificateNo.push(" " + this.groupRenewDetails[i].PolicyNumber + " ");
        }
      } else if (res.ResponseCode == 0) {
        const alertModel = new MatDialogConfig();
        alertModel.disableClose = true;
        alertModel.id = "modal-component";
        alertModel.height = "270px";
        alertModel.width = "850px";
        alertModel.data = {
          title: "Alert Model",
          description: '<h4 style = "pointer-events:visible;font-size: 15px;font-weight: 500;"> We have received your payment. Reach on <a href="mailto:Care.healthinsurance@adityabirlacapital.com"> care.healthinsurance@adityabirlacapital.com </a> or call <a href="tel:1800-270-7000">1800-270-2700</a>.<br> Reference Number: ' + this.ReferenceNo[0] + '.</h4>',
          successText: "OK",
          failureText: "cancel",
          showSuccessBtn: true,
          showFaliureBtn: true,

        }
        const modalDialog = this.matDialog.open(SharedAlertModelComponent, alertModel);
      }
    });
  }

  /*--------------------- End of To fetch Thank You Details ----------------------*/

  selectStar(value) {
    this.rateValue = value;
  };
  submitReview(description) {
    if (this.rateValue == undefined || this.rateValue == null) {
      this.messageObj = {
        "messageVal": "Please provide rate value.",
        "classVal": "e",
        "showAlertSwipe": true
      }
     this.alertSwipe.sliderAlertSwipe(this.messageObj)
      // const alertModel = new MatDialogConfig();
      // alertModel.disableClose = true;
      // alertModel.id = "modal-component";
      // alertModel.height = "195px";
      // alertModel.width = "550px";
      // alertModel.data = {
      //   title: "Error",
      //   description: "Please provide rate value.",
      //   successText: "OK",
      //   failureText: "cancel",
      //   showSuccessBtn: true,
      //   showFaliureBtn: true,
      // }
      // const modalDialog = this.matDialog.open(SharedAlertModelComponent, alertModel);
    }
   else if (description == undefined || description == null || description == "") {
      this.messageObj = {
        "messageVal": "Please provide description.",
        "classVal": "e",
        "showAlertSwipe": true
      }
       this.alertSwipe.sliderAlertSwipe(this.messageObj)
      // const alertModel = new MatDialogConfig();
      // alertModel.disableClose = true;
      // alertModel.id = "modal-component";
      // alertModel.height = "195px";
      // alertModel.width = "550px";
      // alertModel.data = {
      //   title: "Error",
      //   description: "Please provide description.",
      //   successText: "OK",
      //   failureText: "cancel",
      //   showSuccessBtn: true,
      //   showFaliureBtn: true,
      // }
      // const modalDialog = this.matDialog.open(SharedAlertModelComponent, alertModel);
    }
    else{
    var submitData = {
      "rating": this.rateValue,
      "Description": description,
      "ReferenceNo": this.ReferenceNo[0],
    }
    this.appservice.show()
    this.appservice.PostApi('https://www.adityabirlacapital.com/healthinsurance/hServices/api/RenewalPolicy/insertRenewFeedback', submitData, Constant.header).subscribe(res => {
      console.log(res);
      this.appservice.hide()
      if (res.code == '1') {
        this.messageObj = {
          "messageVal": "Thanks for your feedback",
          "classVal": "s",
          "showAlertSwipe": true
        }
        this.alertSwipe.sliderAlertSwipe(this.messageObj);
         description = "";
      }
    });
  }
  }
}

